<template>
  <div :class="$style.container">
    <!-- Модальное окно шаринга платежной ссылки в соц сетях и отправки на емейл -->
    <modal-social-share-list></modal-social-share-list>

    <!-- Модальное окно изменения счета -->
    <modal-multi-bill-edit></modal-multi-bill-edit>

    <!-- Модальное окно подтверждения вывода средств -->
    <refund-confirm-modal></refund-confirm-modal>

    <!-- Модальное окно изменения шаблона билета -->
    <ticket-template-dialog></ticket-template-dialog>

    <!-- Модальное окно изменения вариантов вознаграждения -->
    <tips-variants-dialog></tips-variants-dialog>

    <!-- Модальное окно ввода описания для деклорируемой транзакции -->
    <declaration-description-dialog></declaration-description-dialog>

    <!-- Модальное окно для отправки на емейл квитанции по транзакции -->
    <transaction-receipt-modal />

    <cs-preloader-overlay :loading="loading">
      <!-- Панель уведомленияй кабинета -->
      <!-- (вынести сюда оступы) -->
      <cabinet-notification
        v-if="isPersonalProject"
        v-m-b="20"
      ></cabinet-notification>

      <!-- Дашборд проекта -->
      <project-dashboard></project-dashboard>

      <transaction-filters
        ref="TransactionFilters"
        @toggle-block="toggleBillCreated"
      ></transaction-filters>

      <div class="report-list-container">
        <report></report>

        <notice v-if="isDeviceSize.desktop"></notice>
      </div>
    </cs-preloader-overlay>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import CabinetNotification from '@/components/main/CabinetNotification';

import Report from '@/components/main/Report';
import Notice from '@/components/main/Notice';
import TransactionFilters from '@/components/main/TransactionFilters';

import ModalMultiBillEdit from '@/components/modals/ModalMultiBillEdit';
import ModalSocialShareList from '@/components/modals/ModalSocialShareList';

import TicketTemplateDialog from 'modules/Cards/components/TicketTemplateDialog';
import TipsVariantsDialog from 'modules/Cards/components/TipsVariantsDialog';
import DeclarationDescriptionDialog from 'organisms/transaction/declaration/DeclarationDescriptionDialog';

import ProjectDashboard from 'organisms/project/ProjectDashboard';
import RefundConfirmModal from 'organisms/refund/RefundConfirmModal';
import TransactionReceiptModal from 'organisms/receipt/TransactionReceiptModal';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'Cabinet',
  components: {
    CabinetNotification,
    Report,
    Notice,
    TransactionFilters,
    ModalMultiBillEdit,
    ModalSocialShareList,
    TicketTemplateDialog,
    TipsVariantsDialog,
    DeclarationDescriptionDialog,
    ProjectDashboard,
    RefundConfirmModal,
    TransactionReceiptModal,
  },
  head: {
    script: [
      {
        inner: '(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");ym(56244937, "init", {clickmap:true,trackLinks:true,accurateTrackBounce:true,webvisor:true});',
        type: 'text/javascript',
      },
      {
        inner: '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,"script","https://connect.facebook.net/en_US/fbevents.js");fbq("init", "1175137569342493");fbq("track", "PageView");',
        type: 'text/javascript',
      },
      {
        inner: '!function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src="https://vk.com/js/api/openapi.js?167",t.onload=function(){VK.Retargeting.Init("VK-RTRG-470699-8QMTl"),VK.Retargeting.Hit()},document.head.appendChild(t)}();',
        type: 'text/javascript',
      },
      {
        inner: '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start": new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src="https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);})(window,document,"script","dataLayer","GTM-WKBLDC4");',
        type: 'text/javascript',
      },
    ],
    noscript: [
      {
        inner: '<div><img src="https://mc.yandex.ru/watch/56244937" style="position:absolute; left:-9999px;" alt="" /></div>"/>',
      },
      {
        inner: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1175137569342493&ev=PageView&noscript=1"/>',
      },
      {
        inner: '<img src="https://vk.com/rtrg?p=VK-RTRG-470699-8QMTl" style="position:fixed; left:-999px;" alt=""/>',
      },
      {
        inner: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WKBLDC4" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
      },
    ],
  },
  async created() {
    this.loading = true;

    this.GET_GRAPH();

    await Promise.allSettled([
      this.fetchIdentification(),
      this.isCurrencyCrypto ? this.fetchWalletList() : this.fetchCardList(),
      this.fetchLimits(),
      this.FETCH_MARKETPLACE_CATEGORIES(),
    ]);

    if (!this.$route.query.public_id) {
      this.SET_TRANSACTIONS_PARAMS({
        filterBy: this.$route.query.subscriberId ? 'orders' : 'all',
      });

      this.GET_TRANSACTIONS({
        page: 1,
        reset: true,
        checkEmpty: true,
      });
    }

    this.loading = false;

    EVENT_BUS.$on('CABINET_UPDATE', this.cabinetUpdate);
    EVENT_BUS.$on('DEAL_UPDATE', this.dealUpdate);
  },
  mounted() {
    // eslint-disable-next-line no-undef
    fbq('track', 'Contact');

    window.addEventListener('scroll', this.cabinetScrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.cabinetScrollHandler);
  },
  data() {
    return {
      loading: false,
      showBillCleated: true,
    };
  },
  computed: {
    ...mapState([
      'GRAPH',
      'DEVICE',
      'PROJECT_INFO',
      'TRANSACTIONS',
      'MERCHANT_INFO',
      'SELECTED_TRANSACTION',
    ]),
    ...mapGetters([
      'isDeviceSize',
      'userProjectIsInactive',
      'isPersonalProject',
      'isCurrencyCrypto',
    ]),
  },
  methods: {
    toggleBillCreated() {
      if (this.isDeviceSize.laptop) {
        return;
      }

      this.showBillCleated = !this.showBillCleated;
    },
    onCopy() {
      this.$copyText(this.PROJECT_INFO.payLink);

      this.$alert({
        type: 'ok',
        text: 'link.copied',
      });
    },
    cabinetScrollHandler() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0;
      let offset = scrollTop + window.innerHeight;
      let height = document.documentElement.offsetHeight;

      // load and push transactions when reaches bottom
      let heightFactor = 100;
      if (offset + heightFactor >= height && !this.TRANSACTIONS.loading) {
        this.GET_TRANSACTIONS_AFTER_SCROLLING();
      }

      // filters block
      let arrangerRect = this.$refs.TransactionFilters?.$refs?.arranger?.getBoundingClientRect();
      let arrangerOffset = arrangerRect?.top ?? 0;

      this.SET_SCROLL_STATES({
        type: 'Filters_block_is_fixed',
        params: arrangerOffset <= 5,
      });
    },
    cabinetUpdate() {
      this.fetchLimits();

      this.GET_TRANSACTIONS({
        page: 1,
        reset: true,
      });

      this.GET_GRAPH();
      this.CLOSE_TRANSACTION();
    },
    dealUpdate(data) {
      this.UPDATE_DEAL_STATUS(data.deal);
    },
    ...mapActions([
      'GET_GRAPH',
      'GET_TRANSACTIONS',
      'FETCH_MARKETPLACE_CATEGORIES',
      'GET_TRANSACTIONS_AFTER_SCROLLING',
    ]),
    ...mapActions('identity', ['fetchIdentification']),
    ...mapActions('bills', ['fetchLimits']),
    ...mapActions('cards', ['fetchCardList']),
    ...mapActions('wallet', ['fetchWalletList']),
    ...mapMutations([
      'SELECT_TRANSACTION',
      'SET_MODAL_PARAMS',
      'SET_SCROLL_STATES',
      'CLOSE_TRANSACTION',
      'SET_TRANSACTIONS_PARAMS',
      'UPDATE_DEAL_STATUS',
    ]),
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    max-width: 640px
    margin: 0 auto 100px
    padding: 0

    +respond-to('small')
      padding: 20px 0

    +respond-to('small-medium')
      max-width: 100%

    +respond-to('medium')
      max-width: 980px
</style>

<style lang="sass" scoped>
  .report-list-container
    position: relative
    display: flex

    +respond-to('small-medium')
      margin: 0 20px
</style>
